export const MuiDrawer = {
  MuiDrawer: {
    // paper: {
    //   backgroundColor:
    // }
  },
};
